module.exports = __webpack_public_path__ + "static/media/lto-dill-dt-en.7f216b2d.jpg";